import { useState } from 'react';
import RULES from './ThithiNirnayaData.json';

const T = { bg:'#f0f5e8', cream:'#fffef0', greenDk:'#1b5e20', maroon:'#6d1b1b', orange:'#e65100', border:'#c8e6c9', header:'linear-gradient(135deg,#090b72,#1a237e)' };

const ThithiNirnayaRulesPage = () => {
  const [open, setOpen] = useState(null);
  
  return (
    <div style={{background:T.bg,minHeight:'80vh',padding:'10px'}}>
      <div style={{background:T.header,padding:'12px',borderRadius:'10px',textAlign:'center',marginBottom:'10px'}}>
        <h1 style={{color:'#fff',margin:0,fontSize:'1rem',fontWeight:900}}>📏 திதி நிர்ணய விதிகள்</h1>
        <div style={{color:'#c8e6c9',fontSize:'0.7rem'}}>Thithi Nirnaya Rules (Full Version)</div>
      </div>
      
      <div style={{fontSize:'0.75rem',color:T.maroon,background:T.cream,padding:'8px',borderRadius:'6px',marginBottom:'10px',border:'1px solid '+T.border}}>
        திதி, நக்ஷத்ரம், யோகம் முதலிய பஞ்சாங்க அங்கங்களின் நிர்ணயம் எவ்வாறு செய்யப்படுகிறது என்பதற்கான சாஸ்திர விதிகள்.
      </div>
      
      {RULES.map((r, i) => (
        <div key={i} style={{marginBottom:'4px'}}>
          <div onClick={() => setOpen(open === i ? null : i)} style={{
            background: open === i ? T.greenDk : '#fff', color: open === i ? '#fff' : T.greenDk, padding: '10px 12px',
            borderRadius: open === i ? '8px 8px 0 0' : '8px', cursor: 'pointer', fontWeight: 700, fontSize: '0.85rem',
            border: '1px solid ' + T.border, display: 'flex', justifyContent: 'space-between', alignItems: 'center'
          }}>
            <span>{i+1}. {r.title}</span>
            <span>{open === i ? '▲' : '▼'}</span>
          </div>
          {open === i && (
            <div 
              style={{
                background: T.cream, padding: '15px', border: '1px solid ' + T.border, 
                borderTop: 'none', borderRadius: '0 0 8px 8px', fontSize: '0.8rem', 
                lineHeight: 1.8, color: T.maroon
              }}
              dangerouslySetInnerHTML={{ __html: r.html }}
            />
          )}
        </div>
      ))}
      
      {/* Styles for the injected HTML */}
      <style>{`
        .myol { padding-left: 20px; margin-top: 5px; }
        .myol li { margin-bottom: 8px; }
        hr { border: 0; height: 1px; background: #e65100; margin: 10px 0; opacity: 0.3; }
        table { border-collapse: collapse; margin-top: 10px; }
        td { border: 1px solid #c8e6c9; padding: 6px; }
      `}</style>
    </div>
  );
};

export default ThithiNirnayaRulesPage;